export default __webpack_public_path__ + "01343c38.jpg";